$( document ).ready(function() {
    loadCart();
    initCart();
    // discountLineItemPrice();
    //initButtonChangeQuantityOnProductPage();
    //initUpdateQuantityOnCartPage();
    //initPromoCodeForm();

});

async function doesDiscountCodeExist(discountCode) {
    const result = await fetch(`/admin/discount_codes/lookup.json?code=${discountCode}`);

    if (result.status == 200) {
        setCookie("discount_code", discountCode, 10);
        document.location.href=document.location.origin + '/discount/' + discountCode + '?redirect=/checkout';
    }
}

function initPromoCodeForm(){
    $('.add-promocode').on('click', function(){
       $(this).hide();
       $('#promocode-form').show();
    });

    $('#apply_promo_code').on('click', function(){
        var customer_promo_code = $('#customer_promo_code').val();
        doesDiscountCodeExist(customer_promo_code);
    });

    var res_cookie = getCookie('discount_code');
    if(res_cookie!='' && res_cookie!=null){
        $('#customer_promo_code_res').text(res_cookie);
        $('#apply_promo_code').hide();
        $('#promo_code_fixed').show();
    }
}

// get a list of products via an ajax query
// map it to only include handle, id, and variants
async function getProductVariantByIDs(product_id, variant_id) {
  const response = await $.ajax('/products.json?limit=250');
  // .map(product => product.variants)
  const variants = response.products.filter(product => product.id === product_id).map(product => product.variants)[0];
  // console.log("DEBUG products, variants, productID, variantID:", response.products, variants, product_id, variant_id)
  const variant = variants.filter(v => v.id === variant_id)[0];
  return variant;
}

function getLinePrice(isDiscounted, linePrice, discountedPrice) {
  if (isDiscounted) {
      return `<h4><span style="text-decoration: line-through;">${linePrice.toFixed(2)} CAD</span><span style="color: red;">${discountedPrice.toFixed(2)} CAD </span></h4>`;
  }
  return `<h4>${linePrice?.toFixed(2)} CAD</h4>`;
}

async function getCartNotificationText(items) {
  const period = await $.get('/collections/period/products.json').then(response => response.products.map(product => product.handle))
  const lingerie = await $.get('/collections/lingerie/products.json').then(response => response.products.map(product => product.handle))
  const underwear = await $.get('/collections/all-underwear/products.json').then(response => response.products.map(product => product.handle))
  const boxers = await $.get('/collections/knotty-boxers/products.json').then(response => response.products.map(product => product.handle))
  const allDiscountedItems = period.concat(lingerie, underwear, boxers);
  let item_count = 0;

  items.forEach(item => {
    if (allDiscountedItems.indexOf(item.handle) > -1) {
      item_count += item.quantity;
    }
  })

  
  
  switch(item_count) {
    case 0:
    case 1:
      $("#cart-menu-notification p").html(`
        <div>Buy any 2 items & get <span style='text-decoration: none; font-weight: bold'>10% OFF!</span></div>
        <div style="font-size: 10px">(Sale items excluded)</div>
      `);
      break;

    case 2:
      $("#cart-menu-notification p").html(`
        <div>Buy any 3 items & get <span style='text-decoration: none; font-weight: bold'>15% OFF!</span></div>
        <div style="font-size: 10px">(Sale items excluded)</div>
      `);
      break;

    case 3:
      $("#cart-menu-notification p").html(`
      <div>Buy any 4 items & get <span style='text-decoration: none; font-weight: bold'>20% OFF!</span></div>
      <div style="font-size: 10px">(Sale items excluded)</div>
      `);
      break;

    case 4:
      $("#cart-menu-notification p").html(`
      <div>Yay! You're getting <span style='text-decoration: none; font-weight: bold'>20% OFF!</span></div>
      `);
      break;
    default:
      $("#cart-menu-notification p").html(`Yay! You're getting <span style='text-decoration: none; font-weight: bold'>20% OFF!</span>`);
      break;
  }
}

function cartGamificationUpdates(totalPrice, cartQuantity) {
  const primaryText = $("#cart-gamification-primary");
  const progressBar = $("#cart-gamification-progress-bar");
  const tierText = $("#cart-gamification-tier")
  const priceRemainingText = $("#cart-gamification-price-remaining")
  const firstCheck = $("#cart-gamification-progress-bar #first-check");
  const secondCheck = $("#cart-gamification-progress-bar #second-check");
  const thirdCheck = $("#cart-gamification-progress-bar #third-check");
  let percent;
  let tier;
  let priceRemaining;

  function showCheckmarks(num) {
    // reset checkmarks
    firstCheck.hide();
    secondCheck.hide();
    thirdCheck.hide();

    if (num >= 1) {
      firstCheck.show();
    }

    if (num >= 2) {
      secondCheck.show();
    }

    if (num >= 3) {
      thirdCheck.show();
    }
  }

  if (cartQuantity === 0) {
    $(".cart-menu-header h2").hide()
    $(".cart-menu-header #cart-gamification-primary").hide()
    $(".cart-menu-header #cart-gamification-progress-bar").hide()
    return;
  } else {
    $(".cart-menu-header h2").show()
    $(".cart-menu-header #cart-gamification-primary").show()
    $(".cart-menu-header #cart-gamification-progress-bar").show()
  }
  
  // each tier has a 10% offset for visual effect
  if (totalPrice >= 0 && totalPrice < 60) {
    percent = Math.round(totalPrice / 60 * 15);
    tier = "FREE Shipping";
    priceRemaining = Math.round(60 - totalPrice);
    showCheckmarks(0);
    
  } else if (totalPrice >= 60 && totalPrice < 99) {
    percent = Math.round(totalPrice / 99 * 40);
    tier = "10% OFF";
    priceRemaining = Math.round(99 - totalPrice);

    showCheckmarks(1);
    
  } else if (totalPrice >= 99 && totalPrice <= 120) {
    percent = Math.round(totalPrice / 120 * 65);
    tier = "15% OFF + FREE Gift";
    priceRemaining = Math.round(120 - totalPrice);

    showCheckmarks(2);
    
  } else {
    
    percent = 100;
    primaryText.html("You're receiving <b>15% OFF + a FREE Gift!</b>")
    progressBar.attr("style", `
    width: 100%; 
    height: 30px; 
    border-radius: 15px; 
    background: linear-gradient(to right, #FC6785 ${percent}%, #FFEBED 0%);
    display: flex; 
    align-items: center; 
    justify-content: space-evenly;
    margin: 10px 0 50px
  `);
    showCheckmarks(3);
    return;
  }
  progressBar.attr("style", `
    width: 100%; 
    height: 30px; 
    border-radius: 15px; 
    background: linear-gradient(to right, #FC6785 ${percent}%, #FFEBED 0%);
    display: flex; 
    align-items: center; 
    justify-content: space-evenly;
    margin: 10px 0 50px
  `);
  primaryText.html(`You are <b>$${priceRemaining}</b> away from <b>${tier}</b>`)
}

async function loadCart() {

    const boxerProductTitles = await $.get('/collections/ynvpbgqtew91ci1vd24tynvuzgxl/products.json').then(response => response.products.map(product => product.title));
    let boxerTotalPrice = 0;
    let freeMysteryBoxerInCart = false;
    
    // this needs to be refactored, like seriously...
    return await jQuery.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'jsonp',
        success: async function(data) {

            var item_count = data['item_count'];
            var total_price = data['total_price']/100;
            var cart_has_subscibe_product = 0;

            getCartNotificationText(data.items);
            cartGamificationUpdates(total_price, item_count);

            //If there are items in cart
            if ( item_count > 0 ) {

                // cart count
                jQuery('.cart-count').text(item_count);

                // mini cart data
                jQuery('.mini-cart').attr('id','mini-cart');
                jQuery('.mini-cart-subtotal').text( '$ ' + total_price.toFixed(2) + ' CAD' );
                var cart_list = [];
                var cart_has_subscibe_product = 0;

                /* We can retrieve a getFreeShippingHandle for all products except subscription products.
                   Then we can append it to the HTML below.
                */
                async function getFreeShippingHandle(product_title) {
                  const subscription_titles = await $.get('/collections/shop-subscription/products.json')
                    .then(data => data.products)
                    .then(products => products.map(product => product.title))
                  if (subscription_titles.indexOf(product_title) === -1) 
                    return `<div class="product-page-main-labs" style="padding-top: 2px; width: fit-content;">
                      <span style="background-color: var(--colorwarmpink); color: #aa2943; padding-right: 8px; padding-left: 8px; font-size: 11px;">
                        Free shipping
                    </span>
                  </div>`
                  return `<div></div>`
                }
              
                const subscription_titles = []
                for( var i = 0; i < item_count; i++ ){
                    if(data['items'][i]) {
                        if (data['items'][i]['id']) {

                            var item_id = data['items'][i]['id'];
                            var product_title = data['items'][i]['product_title'];
                            var variant_title = data['items'][i]['variant_title'];
                            let variant_id = data['items'][i]['variant_id'];
                            var product_id = data['items'][i]['product_id'];
                            var product_handle = data['items'][i]['handle'];
                            var quantity = data['items'][i]['quantity'];
                            var line_price = data['items'][i]['price'] / 100;
                            let discounted_price = data['items'][i]['discounted_price'] / 100;
                            let isDiscounted = data['items'][i]['line_level_total_discount'] > 0;
                            var product_url = data['items'][i]['url'];
                            var image_url = data['items'][i]['image'];
                            var variants = data['items'][i]['variant_options'];
                            var product_oz = Math.ceil(data['items'][i]['grams']/28.34952);
                            var properties = data['items'][i]['properties'];
                            var html_subscribe = '';


                            // mystery boxer stuff
                            if (boxerProductTitles.indexOf(product_title) > -1) {
                              boxerTotalPrice += line_price * quantity;
                            }

                            if (variant_id === 41059364339805) {
                              freeMysteryBoxerInCart = true;
                            }
                            

                            if(properties != '' && properties != null && properties != 'undefined' &&  typeof properties !== 'undefined') {
                                if(properties.subscribe == 1){
                                    cart_has_subscibe_product = 1;
                                    html_subscribe = '<span>Subscription</span>';
                                }
                            }

                            var options = [];
                            for (var o = 0; o < variants.length; o++) {
                                var selected = data['items'][i]['options_with_values'][o];
                                if (selected !== 'Default Title') {
                                    options.push('<h5>' + selected.name + ': ' + selected.value + '</h5>');
                                }
                            }

                            var selected_options = options.join('');

                            var min_quantity = 1;

                            var html = ' <div class="cart-menu-row">' +
                                '                <div class="cart-menu-col-left">' +
                                '                    <div class="cart-menu-col-left-img">' +
                                '                        <img src="' + image_url + '" />' +
                                '                    </div>' +
                                '                    <div class="cart-menu-col-left-info"><a href="' + product_url + '">' +
                                '                        <h3 class="cart-menu-col-left-info-title">' + product_title + '</h3></a>' + html_subscribe +
                                '                        ' + selected_options + '' + await getFreeShippingHandle(product_title) +
                                '                    </div>'+
                                '                </div>' +
                                '                <div class="cart-menu-col-right">' +
                                '                    <h4 id="cart-menu-col-right-line-price">' + getLinePrice(isDiscounted, line_price, discounted_price) + '</h4>' +
                                '                    <div class="number-input change_product_count" data-pid="'+ product_id+'" data-min-quantity="' + min_quantity + '"  data-variant="' + data['items'][i]['variant_id'] + '" data-line-index="' + i + '">' +
                                '                        <button class="cart-button-quantity-change icon-minus"></button>' +
                                '                        <input id="product_quantity_' + data['items'][i]['variant_id']  + '" min="1" max="99" name="quantity" value="' + quantity + '" type="number">' +
                                '                        <button class="cart-button-quantity-change plus icon-plus"></button>' +
                                '                    </div>' +
                                '                    <span class="remove-item-from-cart"  data-pid="'+ product_id + '" data-productId="' + item_id + '">Remove</span>' +
                                '                </div>' + 
                                '            </div>'

                            cart_list.push(html);
                        } //endif
                    }
                } // endfor

                // if boxer total price is greater than or equal to 90
                // we add free mystery boxer gift
                if ((boxerTotalPrice >= 90 || total_price >= 120) && !freeMysteryBoxerInCart) {
                  await jQuery.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                      'id': 41059364339805,
                      'quantity': 1
                    },
                    dataType: 'json'
                  })

                  await jQuery.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: {
                      'id': 41059364339805,
                      'quantity': 1
                    },
                    dataType: 'json'
                  })

                  loadCart();
                  initCart();
                  showSmallCart();                  
                } else if (boxerTotalPrice < 90 && total_price < 120 && freeMysteryBoxerInCart) {
                  removeItemCountInCart(41059364339805,0,0,null);
                }
                
                if(cart_has_subscibe_product==1){
                    $('.recharge-checkout').show();
                    $('.shopify-checkout').hide();
                }else{
                    $('.recharge-checkout').hide();
                    $('.shopify-checkout').show();
                }

                jQuery('.mini-products-list').html( cart_list.join('') );
                $('.no-items-in-cart').hide();

                jQuery('.remove-item-from-cart').on('click',function(){
                    var product_variant_id = $(this).attr('data-productId');
                    var prod_id = $(this).attr('data-pid');
                    $(this).parent().parent().remove();
                    removeItemCountInCart(product_variant_id,0,0,prod_id);
                });


                jQuery('.change_product_count .cart-button-quantity-change').on('click', function(){
                    $('.mini-cart-block').hide();
                    $('.loadingCart').show();

                    var product_variant_id = $(this).closest('.change_product_count').attr('data-variant');
                    var product_id = $(this).closest('.change_product_count').attr('data-pid');
                    var current_element_quantity = parseInt($('#product_quantity_' + product_variant_id).val());
                    var current_element_properties = $(this).closest('.change_product_count').attr('data-properties');
                    var current_element_min_quantity = $(this).closest('.change_product_count').attr('data-min-quantity');
                    let line_index = parseInt($(this).closest('.change_product_count').attr('data-line-index')) + 1;

                    // prevent allowing free mystery gift to be updated 
                    if (product_variant_id === "41059364339805") return;
                  
                    if($(this).hasClass('icon-plus')) {
                        var subscribe_item = $(this).data('subscribe_item');
                        var new_element_quantity = current_element_quantity + 1;
                        updateItemCountInCart(product_variant_id, new_element_quantity, current_element_properties, subscribe_item);
                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                    }else{
                        var new_element_quantity = current_element_quantity - 1;
                        removeItemCountInCart(product_variant_id,new_element_quantity, 0, product_id);
                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                    }
                });

                $('.mini-cart-block').show();
                $('.loadingCart').hide();

            }else{
                $('.loadingCart').hide();
                $('.mini-products-list').empty().show();
                $('.no-items-in-cart').show();
                $("#cart-menu-divider").hide();
                $('.mini-cart-subtotal').text('');
            }
        }
    });
}

// function //refreshCart() {
//     // every time we perform a button quantity change, we want to
//     // refresh the cart, once again
//     // reload shopping cart menu notification
//     if ($("#cart-menu-notification").length) {
//       $("#cart-menu-notification").load(location.href + " #cart-menu-notification");
//     }
// }

async function initCart() {
    return await jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(data) {

            var item_counts_in_cart = data.items.length;
            var total_items_in_cart = data.item_count;

            if(item_counts_in_cart>0) {
                  $('#header_cart_quantity').show().text(data.items.length);
                  $('.no-items-in-cart, .small-cart-empty').hide();
                  $('.small-cart-checkout-block, .also-love-block').show();
            }else{
                  $('.no-items-in-cart, .small-cart-empty').show();
                  $('#header_cart_quantity').text(0);
                  $('.small-cart-checkout-block, .also-love-block').hide();
            }
        }
    });
}

function initButtonChangeQuantityOnProductPage() {
    $('.icon-minus').addClass('no-active');

    $('.button-quantity-change').on('click', function(){

        var product_id = $(this).data('product_id');
        var selected_qty = parseInt($('#product_selected_quantity_' + product_id).val());
        var max_qty = parseInt($('#product_max_quantity_' + product_id).val());
        var min_qty = $('#product_min_quantity_' + product_id).val();

        var new_qty = selected_qty * 1;

        if($(this).hasClass('icon-plus')) {
            if(max_qty>selected_qty) {
                new_qty++;
            }
        }else{
            if(new_qty>1) {
                new_qty--;
            }
        }
        new_qty = (isNaN(new_qty))?1:new_qty;

        if(new_qty<min_qty){
            new_qty = min_qty;
        }

        if(new_qty==min_qty){
            $('.icon-minus').addClass('no-active');
        }else{
            $('.icon-minus').removeClass('no-active');
        }

        if(new_qty<10){
            new_qty = '0' + new_qty
        }

        $('#product_selected_quantity_' + product_id).val(new_qty);

        if(max_qty==new_qty) {
            $('.icon-plus').hide();
        }else{
            $('.icon-plus').show();
        }
    });
}

function removeItemCountInCart(variant_id,new_count, reload, product_id) {
    var data = {
        'id': variant_id,
        'quantity': new_count
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function(data) {
            initCart();
            loadCart();
            if(reload == 1 || document.location.pathname=='/cart'){
                document.location.reload();
            }
            // if(product_id !== undefined) {
            //     document.getElementById(`${product_id}-small-cart-upsell`).style.display = 'block'
            // }
            // every time we perform a button quantity change, we want to
            // refresh the cart, once again
            // reload shopping cart menu notification
            // //refreshCart();
        },
        error: function(error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            initCart();
            loadCart();
        }

    });
}

function initUpdateQuantityOnCartPage(){
    $('.cart-quantity-update').on('click', function(){
        $('.cart-loading').show();
        $('.product-cart-row').hide();

        var product_id = $(this).data('product_id');
        var variant_id = $('#cart_product_variant_id_' + product_id).val();

        var current_element_quantity = parseInt($('#product_selected_quantity_' + product_id).val());
        

        if($(this).hasClass('icon-plus')) {
            updateItemCountInCart(variant_id, current_element_quantity, '', '', 1);
        }else{
            if($(this).hasClass('delete-item-from-cart')){
                current_element_quantity = 0;
            }

            removeItemCountInCart(variant_id, current_element_quantity, 1);
        }

    });
}

function updateItemCountInCart(variant_id,new_count, properties, subscribe_item, reload) {

        let data = {
            "id": variant_id,
            "quantity": new_count,
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function(data) {
                initCart();
                loadCart();
                if(reload == 1 || document.location.pathname=='/cart'){
                    document.location.reload();
                }

                // //refreshCart();
            },
            error: function(error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
                initCart();
                loadCart();
            }
        });

}

function showSmallCart(){
    if($('.cart-menu-modal').hasClass('cart-menu-modal-active')){

    }else {
        $('.cart-menu').click();
    }
}

function addItemToCartRecharge(swatch_id) {

    var variant_id = $('.product-form__variants_' + swatch_id).val();

    if(variant_id) {

        data = {
            "id": variant_id,
            "quantity": 1,
            "properties": {
                "subscribe": 1,
                "shipping_interval_unit_type": 'Months',
                "shipping_interval_frequency": $('#subscribe-details-selector').val()
            }
        }
        

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function (e) {
                initCart();
                loadCart();
                showSmallCart();
            },error:function(error){
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });
    }else{
        alert('Error. Can\'t add this product to cart!')
    }

}

// this is when we actually click a product then press add to cart
function addItemToCart() {    
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $('.product-form-pdp').serialize(),
            dataType: 'json',
            success: function (data) {
                // //refreshCart();
                loadCart();
                initCart();
                showSmallCart();
            },
            error: function (error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });

}

// when we click the quick add button on the shop's home screen, it adds to cart immediately
function addItemQuickShopToCart(form_id, product_id) {

    // document.getElementById("best-selling-horizontal-menu").style.overflowX = 'auto';
    // document.getElementById("best-selling-horizontal-menu").style.overflowY = 'hidden';
  
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $('#form_add_product_' + form_id).serialize(),
        dataType: 'json',
        success: function () {
            // //refreshCart();
            loadCart();
            if (product_id !== undefined)
                document.getElementById(`${product_id}-small-cart-upsell`).style.display = 'none'
            initCart();
            showSmallCart();
            if(typeof dont_scroll_top == 'undefined') {
                $("html, body").animate({scrollTop: 0}, 1000);
            }
            closeQuickModal();
        },
        error: function (error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function addSubscribeItemToCart(variant_id, product_id) {

    if(product_id>0){
        var qty = parseInt($('#product_block_index_' + product_id + ' .product_selected_quantity').val());
        var properties = $('#product_block_index_' + product_id + ' .product_extra_properties').val();
        var selling_plan = $('#product_block_index_' + product_id + ' input[name="selling_plan"]').val();
        var min_quantity = $('#product_min_quantity_' + product_id).val();
    }else {
        var qty = parseInt($('#product_selected_quantity').val());
        var properties = $('.product_extra_properties').val();
        var selling_plan = $('input[name="selling_plan"]').val();
        var min_quantity = $('.product_min_quantity').val();
    }

    if(!qty){
        qty = 1;
    }

    if(qty<min_quantity){
        qty = min_quantity;
    }

    setTimeout(function() {
        if(properties!='') {
            var data = {
                "id": variant_id,
                "quantity": qty,
                "selling_plan": selling_plan,
                "properties": { properties }
            }
        }else{
            var data = {
                "id": variant_id,
                "quantity": qty,
                "selling_plan": selling_plan
            }
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                //refreshCart();
                initCart();
                loadCart();
                showSmallCart();
            },
            error: function(error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });
    }, 100);

}

function quickAddItemToCart(variant_id, product_id) {

    if(product_id>0){
        var quantity = parseInt($('#product_selected_quantity_' + product_id).val());
    }else{
        var quantity = 1;
    }

    var data = {
        "id": variant_id,
        "quantity": quantity
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            if(document.location.pathname=='/cart'){
                document.location.reload();
                //refreshCart();
            }else{
                initCart();
                loadCart();
                showSmallCart();
            }
        },
        error: function(error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}


function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

